import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, Collapse, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { observer } from "mobx-react-lite";
import { useCallback, useEffect, useRef, useState, useMemo } from "react";
import ChannelItem from "@/components/Chat/ChannelItem";
import { getRootStore } from "@/stores/RootStore";
import styles from "@/styles/ChannelList.module.less";
const ChannelList = observer(() => {
    const { chatStore } = getRootStore();
    const [search, setSearch] = useState("");
    const searchRef = useRef(null);
    // Ctrl+K focuses search input
    const handleKeyDown = useCallback((e) => {
        if ((e.ctrlKey || e.metaKey) && e.key === "k") {
            e.preventDefault();
            searchRef.current?.focus();
        }
    }, []);
    useEffect(() => {
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [handleKeyDown]);
    const filterChannels = (channels) => {
        if (!search.trim())
            return channels;
        const q = search.trim().toLowerCase();
        return channels.filter((ch) => ch.displayName.toLowerCase().includes(q));
    };
    const filteredRoute = useMemo(() => filterChannels(chatStore.routeChannels), [chatStore.routeChannels, search]);
    const filteredSupport = useMemo(() => filterChannels(chatStore.supportChannels), [chatStore.supportChannels, search]);
    const filteredSystem = useMemo(() => filterChannels(chatStore.systemChannels), [chatStore.systemChannels, search]);
    const handleChannelClick = (channelId) => {
        chatStore.selectChannel(channelId);
    };
    const renderGroup = (channels) => {
        if (channels.length === 0) {
            return _jsx("div", { className: styles.emptyText, children: "\u041D\u0435\u0442 \u043A\u0430\u043D\u0430\u043B\u043E\u0432" });
        }
        return channels.map((ch) => (_jsx(ChannelItem, { channel: ch, isActive: chatStore.activeChannelId === ch.id, onClick: () => handleChannelClick(ch.id) }, ch.id)));
    };
    const unreadCount = (channels) => channels.reduce((sum, ch) => sum + ch.unreadCount, 0);
    const collapseItems = [
        {
            key: "route",
            label: (_jsxs("span", { className: styles.groupLabel, children: ["\u041C\u0430\u0440\u0448\u0440\u0443\u0442\u044B", _jsx(Badge, { count: unreadCount(filteredRoute), size: "small" })] })),
            children: renderGroup(filteredRoute),
        },
        {
            key: "support",
            label: (_jsxs("span", { className: styles.groupLabel, children: ["\u0422\u0435\u0445\u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430", _jsx(Badge, { count: unreadCount(filteredSupport), size: "small" })] })),
            children: renderGroup(filteredSupport),
        },
        {
            key: "system",
            label: (_jsxs("span", { className: styles.groupLabel, children: ["\u0421\u0438\u0441\u0442\u0435\u043C\u043D\u044B\u0435", _jsx(Badge, { count: unreadCount(filteredSystem), size: "small" })] })),
            children: renderGroup(filteredSystem),
        },
    ];
    return (_jsxs("div", { className: styles.container, children: [_jsx("div", { className: styles.searchWrapper, children: _jsx(Input, { ref: searchRef, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043A\u0430\u043D\u0430\u043B\u0430... (Ctrl+K)", prefix: _jsx(SearchOutlined, {}), value: search, onChange: (e) => setSearch(e.target.value), allowClear: true }) }), _jsx("div", { className: styles.collapseWrapper, children: _jsx(Collapse, { defaultActiveKey: ["route", "support", "system"], ghost: true, items: collapseItems }) })] }));
});
ChannelList.displayName = "ChannelList";
export default ChannelList;
